import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { AccountAuthActions } from "../actions";

@Injectable()
export class AccountAuthFacade {
  constructor(private readonly store: Store<unknown>) {}

  keycloakSignIn() {
    this.store.dispatch(AccountAuthActions.keycloakSignIn());
  }

  keycloakSignOut() {
    this.store.dispatch(AccountAuthActions.keycloakSignOut());
  }
}
